import * as React from 'react';
import { Button } from 'antd';
import { ButtonProps } from 'antd/lib/button';

import { palette } from 'theme/variables';

/* Gold accent button — for "+ Add" / "+ New" CTAs (per design brief Option B v4).
   Sets inline `style` with `!important` directly via DOM API to win over all
   global !important Ant Design overrides. */

const applyStyle = (el: HTMLElement | null, hover: boolean) => {
    if (!el) {
        return;
    }
    el.style.setProperty('background', palette.gold, 'important');
    el.style.setProperty('background-color', palette.gold, 'important');
    el.style.setProperty('border-color', palette.gold, 'important');
    el.style.setProperty('color', palette.bottle, 'important');
    el.style.setProperty('font-weight', '700', 'important');
    el.style.setProperty('font-family', "'Inter', sans-serif", 'important');
    el.style.setProperty('border-radius', '999px', 'important');
    el.style.setProperty('padding-left', '22px', 'important');
    el.style.setProperty('padding-right', '22px', 'important');
    el.style.setProperty('opacity', hover ? '0.85' : '1', 'important');
    el.style.setProperty('transition', 'opacity 0.15s ease', 'important');
    el.style.setProperty('box-shadow', 'none', 'important');
};

const applyIconColor = (el: HTMLElement | null) => {
    if (!el) {
        return;
    }
    el.querySelectorAll<HTMLElement>('.anticon').forEach((icon) => {
        icon.style.setProperty('color', palette.bottle, 'important');
    });
};

export const GoldButton: React.FC<ButtonProps> = ({ children, ...rest }) => {
    const ref = React.useRef<HTMLElement | null>(null);
    const [isHover, setIsHover] = React.useState(false);

    React.useLayoutEffect(() => {
        applyStyle(ref.current, isHover);
        applyIconColor(ref.current);
    });

    return (
        <Button
            {...rest}
            ref={(node) => {
                // Antd Button forwards ref to the DOM button element
                ref.current = (node as unknown as HTMLElement) || null;
            }}
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
            onFocus={() => setIsHover(true)}
            onBlur={() => setIsHover(false)}
        >
            {children}
        </Button>
    );
};
